import { isFactory } from './matcherFactory';

const isStandard = isFactory('standard');
const isAssist = isFactory('assist');

export { isStandard, isAssist };
